import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import { parseCourseStatus } from "../utils/parseCourseStatus";

export const getRecommendCourses = async ({ studentId, courseId }) => {
  const res = await axios.middleware("/aluno.asmx/disciplinas_recomendadas", {
    params: {
      alunoid: studentId,
    },
  });
  return res[0].data.map((course) => {
    return { ...course, ...parseCourseStatus(course) };
  });
};

export const useRecommendedCourses = ({ config, params = {} } = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "recommendedCourses",
      { studentId: _cookies.getItem("auth").user.alunoid, ...params },
    ],
    queryFn: () =>
      getRecommendCourses({
        studentId: _cookies.getItem("auth").user.alunoid,
        ...params,
      }),
  });
};
